import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { captureExceptionNewRelic } from '~components/logger';
import ErrorPage from '~pages/ErrorPage';

type ErrorBoundaryProps = {
    children: React.ReactNode;
};

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
    return (
        <ReactErrorBoundary
            onError={captureExceptionNewRelic}
            fallback={<ErrorPage />}
        >
            {children}
        </ReactErrorBoundary>
    );
};

export { ErrorBoundary };
